<template>
  <header>
    <div class="container">
      <div class="header-content">
        <div class="logo" style="color: black">
          政经事 Roadlink GLB
          <!-- <img src="../assets/logo.png"/> -->
        </div>

        <!-- 汉堡菜单按钮 -->
        <div class="mobile-menu" @click="toggleMobileMenu">
          <img
            src="../assets/hangbag_menu.png"
            style="height: 32px; width: 32px; margin-left: 10px"
          />
        </div>

        <!-- 导航菜单 -->
        <nav :class="{ show: mobileMenuOpen }">
          <ul>
            <li v-for="item in navItems" :key="item.id">
              <router-link
                :to="item.path"
                :class="{ active: $route.name === item.name }"
                @click.native="closeMobileMenu"
              >
                {{ item.text }}
              </router-link>
            </li>
          </ul>
        </nav>
        <!-- <div class="auth-buttons">
          <button v-if="!user">&nbsp;</button>
          <button v-if="user">&nbsp;</button>
        </div> -->
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  inject: ["app"],
  data() {
    return {
      mobileMenuOpen: false,
      navItems: [
        { id: "home", text: "Home", path: "/", name: "Home" },
        { id: "news", text: "News", path: "/news", name: "News" },
        { id: "cases", text: "Cases", path: "/cases", name: "Cases" },
        { id: "products", text: "Products", path: "/products", name: "Products" },
        { id: "contact", text: "Contact", path: "/contact", name: "Contact" },
        // { id: 'about', text: 'About', path: '/about', name: 'About' },
        // { id: 'services', text: 'Services', path: '/services', name: 'Services' }
      ],
    };
  },
  // 添加这个方法以便从父组件调用
  closeMobileMenu() {
    console.log("closeMobileMenu");
    this.mobileMenuOpen = false;
  },
  computed: {
    user() {
      return this.app.user;
    },
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },

    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },

    showLoginModal() {
      this.app.showLoginModal = true;
      this.closeMobileMenu();
    },

    logout() {
      this.app.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.closeMobileMenu();
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },

  // 监听路由变化，关闭移动菜单
  watch: {
    $route() {
      this.closeMobileMenu();
    },
  },
};
</script>

<style scoped>
header {
  background: white;
  color: white;
  padding: 15px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.logo {
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
}

.logo i {
  margin-right: 10px;
  color: #4dabf7;
}

/* 桌面端导航样式 */
nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

nav li {
  margin-left: 25px;
}

nav a {
  color: #303030;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 14px;
  transition: all 0.3s ease;
  display: block;
}

nav a:hover,
nav a.active {
  background-color: #265fff;
  color: white;
}

.auth-buttons {
  display: flex;
  gap: 10px;
}

.auth-buttons button {
  background-color: transparent;
  color: #303030;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

/* 移动端汉堡菜单按钮 */
.mobile-menu {
  display: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  padding: 5px;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .header-content {
    flex-wrap: wrap;
  }

  /* 汉堡菜单按钮显示 */
  .mobile-menu {
    display: block;
    order: 2;
  }

  /* 导航菜单默认隐藏 */
  nav {
    order: 3;
    width: 100%;
    margin-top: 15px;
    display: none;
    background-color: #1a3a5f;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }

  nav a {
    color: white;
  }
  /* 显示导航菜单 */
  nav.show {
    display: block;
    animation: slideDown 0.3s ease;
  }

  /* 导航菜单动画 */
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  nav ul {
    flex-direction: column;
    padding: 10px 0;
  }

  nav li {
    margin: 0;
  }

  nav a {
    padding: 12px 20px;
    display: block;
    border-radius: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  nav li:last-child a {
    border-bottom: none;
  }

  nav a:hover,
  nav a.active {
    background-color: rgba(255, 255, 255, 0.15);
  }

  /* 认证按钮调整 */
  .auth-buttons {
    order: 2;
    margin-left: auto;
    margin-right: 15px;
  }

  .auth-buttons button {
    padding: 8px 15px;
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  .logo {
    font-size: 20px;
  }

  .auth-buttons {
    flex-direction: column;
    gap: 5px;
  }

  .auth-buttons button {
    padding: 6px 12px;
    font-size: 12px;
  }

  .mobile-menu {
    font-size: 20px;
  }
}

/* 小屏幕手机优化 */
@media (max-width: 375px) {
  .header-content {
    padding: 0 10px;
  }

  .logo {
    font-size: 18px;
  }

  .logo i {
    margin-right: 8px;
  }
}
</style>